export const CONFLICTING_CNAE_TYPES = {
  HOT_CNAE: 'hot',
  COLD_CNAE: 'cold',
  KEYWORDS_CONFLICT: 'keywords_conflict',
  NON_CONFLICTING: 'non_conflicting',
}

export const CONFLICTING_CNAE_TYPES_MESSAGES = {
  hot: 'Possui atividade conflitante (hot CNAE) com as políticas XP',
  cold: 'Possui atividade conflitante (cold CNAE) com as políticas XP',
  keywords_conflict:
    'Possui atividade (palavras-chave) conflitante com as políticas XP',
  non_conflicting: 'Não possui atividade conflitante com as políticas XP',
}

export const CONFLICT_TYPES_LIST = [
  CONFLICTING_CNAE_TYPES.HOT_CNAE,
  CONFLICTING_CNAE_TYPES.COLD_CNAE,
  CONFLICTING_CNAE_TYPES.KEYWORDS_CONFLICT,
]
